<section>
  <div class="content-section" *ngIf="colorPallet">

    <!-- Tab bar -->
    <div class="palette-tabs">
      <button class="palette-tab" [class.palette-tab--active]="selectedTab === 'Theme'"
        (click)="changeTabs('Theme')">Themes</button>
      <button class="palette-tab" [class.palette-tab--active]="selectedTab === 'Custom'"
        (click)="changeTabs('Custom')">Custom</button>
    </div>

    <!-- Theme list -->
    <ng-container *ngIf="selectedTab === 'Theme'">
      <div class="theme-card" *ngFor="let theme of themes"
        [class.theme-card--selected]="templatePage[0].websiteThemeId === theme.id"
        (click)="selectTheme(theme)">
        <div class="theme-swatches">
          <div class="theme-swatch"
            *ngFor="let style of theme.componentStyles; let i = index"
            [style.background]="style.bgColor"
            [class.theme-swatch--first]="i === 0"
            [class.theme-swatch--last]="i === theme.componentStyles.length - 1">
            <span class="swatch-accent" [style.background]="style.accentColor"></span>
          </div>
        </div>
        <svg *ngIf="templatePage[0].websiteThemeId === theme.id" class="theme-check"
          xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="var(--primary-bg-color)" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 6 9 17l-5-5"/>
        </svg>
      </div>
    </ng-container>

    <!-- Custom palette list -->
    <ng-container *ngIf="selectedTab === 'Custom'">
      <div class="custom-swatches">
        <div class="custom-swatch" *ngFor="let style of selectedTheme; let i = index"
          (click)="editColorPallet(style, i)"
          [style.background]="style.bgColor">
          <span class="swatch-accent" [style.background]="style.accentColor"></span>
          <svg class="swatch-edit" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
            viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/>
          </svg>
        </div>
      </div>
    </ng-container>

  </div>

  <!-- Edit color pallet detail view -->
  <div *ngIf="!colorPallet">
    <div class="custom-header">
      <button class="back-btn" (click)="colorPallet=true">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m15 18-6-6 6-6"/>
        </svg>
      </button>
      <p class="header-text">Color Palette</p>
    </div>

    <div class="color-edit-section">
      <p class="edit-label">Background</p>
      <div class="text-background">
        <input type="color" class="color" [(ngModel)]="selectedBgColor" (ngModelChange)="changeBackground()">
        <input type="text" class="color-code" [(ngModel)]="selectedBgColor" (ngModelChange)="changeBackground()">
      </div>
    </div>

    <hr class="divider">

    <div class="color-edit-section">
      <p class="edit-label">Accent</p>
      <div class="text-background">
        <input type="color" class="color" [(ngModel)]="selectedAccentColor" (ngModelChange)="changeAccentColor()">
        <input type="text" class="color-code" [(ngModel)]="selectedAccentColor" (ngModelChange)="changeAccentColor()">
      </div>
    </div>

    <hr class="divider">

    <div class="color-edit-section">
      <p class="edit-label">Preview</p>
      <div class="preview-swatch" [style.background]="selectedBgColor">
        <span class="swatch-accent" [style.background]="selectedAccentColor"></span>
        <span class="preview-label">Custom</span>
      </div>
    </div>
  </div>
</section>
